module.exports = __webpack_public_path__ + "static/img/1-1.a681cfa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/1-1.png
// module id = PwKh
// module chunks = 0